import { FC, ChangeEvent } from 'react'
import { noop } from 'lodash'
import classNames from 'classnames'
import _ from 'lodash'

import { ArrowIcon } from 'shared/assets'
import { useResponsive } from 'shared/hooks'

import styles from './Pagination.module.scss'
import PaginationStyled from './PaginationStyled'
import { IPaginationProps } from './types'

const Pagination: FC<IPaginationProps> = ({
  page = 1,
  count = 1,
  className = '',
  onChange = noop,
  defaultPage = 1,
  variant = 'text',
  itemsperpage = 1,
  shape = 'circular',
}) => {
  const { isTabletS } = useResponsive()

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    onChange?.(event, page)
  }

  if (isTabletS) {
    return (
      <div className={styles.wrapper}>
        <button disabled={page === 1} onClick={() => onChange(_, page - 1)} className={styles.wrapper__item}>
          <ArrowIcon />
          Попередня
        </button>
        <button className={styles.wrapper__item}>
          {page} / {count}
        </button>
        <button disabled={page === count} onClick={() => onChange(_, page + 1)} className={styles.wrapper__item}>
          Наступна
          <ArrowIcon />
        </button>
      </div>
    )
  }

  return (
    <PaginationStyled
      page={page}
      shape={shape}
      count={count}
      variant={variant}
      defaultPage={defaultPage}
      itemsperpage={itemsperpage}
      onChange={handlePageChange}
      className={classNames({ [className]: className })}
    />
  )
}

export default Pagination
